/**
 * Simple event system for cross-component notification status updates
 * Allows BottomNavigation to stay in sync with Interactions page
 */

class NotificationEventEmitter {
  constructor() {
    this.listeners = new Set();
  }

  subscribe(callback) {
    this.listeners.add(callback);
    return () => {
      this.listeners.delete(callback);
    };
  }

  emit(hasUnreadNotifications) {
    this.listeners.forEach(callback => {
      try {
        callback(hasUnreadNotifications);
      } catch (error) {
        console.error('Error in notification event listener:', error);
      }
    });
  }
}

export const notificationEvents = new NotificationEventEmitter();

export const broadcastNotificationStatusChange = (hasUnreadNotifications) => {
  notificationEvents.emit(hasUnreadNotifications);
};